import { Loader, SvgCallIconWorkflow, SvgExpandCCP, SvgMinus } from '@ui-kit'
import React, { ReactNode, useState } from 'react'
import Draggable from 'react-draggable'

export interface CTIHeaderType {
  callStatus?: string
  children?: ReactNode
  showLoader?: boolean
}

const CTIHeader = ({
  callStatus,
  children,
  showLoader = false,
}: CTIHeaderType) => {
  const [isMinimised, setIsMinimised] = useState(false)

  return (
    <Draggable handle=".cti-header-drag" bounds="body">
      <div
        className="fixed bottom-10 right-5 w-[25rem] bg-white shadow-lg rounded-xl border border-tertiary-300 z-[99999]"
        style={{ cursor: 'move' }}
      >
        <div
          className={`cti-header-drag border border-tertiary-300 bg-tertiary-100 py-3 px-5 ${
            isMinimised ? 'rounded-xl' : 'rounded-t-xl'
          }`}
        >
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row items-center gap-2">
              <SvgCallIconWorkflow height={'18'} width={'18'} />
              <span className="text-lg font-extrabold font-primary">
                {callStatus}...
              </span>
            </div>
            {isMinimised ? (
              <button onClick={() => setIsMinimised((prev) => !prev)}>
                <SvgExpandCCP />
              </button>
            ) : (
              <button onClick={() => setIsMinimised((prev) => !prev)}>
              <SvgMinus fill="#5E5E5E" width={'18'} height={'3'} />
            </button>
            )}
          </div>
        </div>

        <div className={isMinimised ? 'hidden' : 'block'}>
          <div style={{ display: showLoader ? 'none' : 'block' }}>
            {children}
          </div>
          {showLoader && (
            <div className="p-4">
              <Loader isGlobal={false} />
            </div>
          )}
        </div>
      </div>
    </Draggable>
  )
}

export default CTIHeader
